import React from "react";
import { IonButton } from "@ionic/react";
import { EmptyStateProps } from "./DataSharingTypes";

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
}) => (
  <div className="flex flex-col items-center justify-center">
    <div className="my-6 bg-white rounded-3xl shadow-md p-6 w-full lg:w-2/3 xl:w-1/2">
      <h2 className="text-xl md:text-2xl font-semibold text-center mb-4">
        {title}
      </h2>
      <p className="text-center text-gray-700 mb-6">{description}</p>
      <div className="flex justify-center">
        <IonButton
          className="w-40 h-12 text-white"
          style={{
            "--border-radius": "24px",
            "--background": "#00b0ca",
          }}
          onClick={onButtonClick}
        >
          {buttonText}
        </IonButton>
      </div>
    </div>
  </div>
);

export default EmptyState;